import { render } from "./ChallengeSection.vue?vue&type=template&id=20cf4d3a&scoped=true"
import script from "./ChallengeSection.vue?vue&type=script&lang=js"
export * from "./ChallengeSection.vue?vue&type=script&lang=js"

import "./ChallengeSection.vue?vue&type=style&index=0&id=20cf4d3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cf4d3a"]])

export default __exports__